import {
  put, takeLatest, all, select, call, take,
} from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';
import { bootstrap } from 'circe/actions';
import { onboardingClient } from 'domain/HttpClients';
import { selectProfile } from 'domain/fuse/auth/profiles/actions';
import { XAxis } from 'recharts';
import uuid from 'uuid/v4';
import { onMessageListener, requestFirebaseNotificationPermission } from './utils';
import { newToken, newNotification } from './actions';

function* doInitForeground() {
  try {
    const token = yield requestFirebaseNotificationPermission();
    yield put(newToken(token));

    while (true) {
      const results = yield onMessageListener();
      yield put(newNotification({ ...results, id: uuid() }));
    }
  } catch (e) {
    console.error(e.message);
  }
}

function* doInitBackground() {
  try {
    const pushChannel = eventChannel((emit) => {
      const channel = new window.BroadcastChannel(PUSH_CHANNEL);
      channel.addEventListener('message', (event) => {
        emit(event);
      });
      return () => {};
    });

    while (true) {
      const { data } = yield take(pushChannel);
      yield put(newNotification({ ...data, id: uuid() }));
    }
  } catch (e) {
    console.error(e.message);
  }
}

function* registerNotification() {
  const state = yield select();
  const token = state.circe.authentication.tokens.idToken;
  const { profileId } = state.app.auth.profile;
  const firebaseToken = state.app.firebase.token;

  try {
    const response = yield onboardingClient
      .Post('/api/notification/register')
      .withHeaders({
        Authorization: `Bearer ${token}`,
        'Content-type': 'application/json',
      })
      .withData({
        channels: [
          {
            channelHandler: firebaseToken,
            channelType: 'WEB',
          },
        ],
        locale: 'en-US',
        platform: 'web',
        profileId,
      })
      .send();
  } catch (e) {
    console.error(e.message);
  }
}
function* watcher(context) {
  yield all([
    takeLatest(bootstrap().type, doInitForeground),
    takeLatest(bootstrap().type, doInitBackground),
    takeLatest(selectProfile().type, registerNotification),
  ]);
}

export default watcher;
